import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import { EdButtonComponent } from "@edenred/components/button";
import { EdModalRef } from "@edenred/components/modals";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
	selector: "er-cancel-prompt",
	templateUrl: "./cancel-prompt.component.html",
	styleUrls: ["./cancel-prompt.component.scss"],
	imports: [
			EdButtonComponent,
			TranslocoPipe
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class CancelPromptComponent {

	constructor(@Inject(EdModalRef) private modalRef: EdModalRef<unknown>) {
	}

	public onStayOnPageClick(): void {
		this.modalRef.close(false)
	}

	public onLeavePageClick(): void {
		this.modalRef.close(true)
	}
}